import { fetch } from '@atlassian/eoc-fetch';
export const getRoutingRules = teamId => fetch(`/v1/teams/${teamId}/routing-rules`);